"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
var _vueTheMask = require("vue-the-mask");
var _vMoney = require("v-money");
var _Colapse = _interopRequireDefault(require("@/ui/components/Colapse"));
var _utils = require("@/utils");
var _ListItensLeft = _interopRequireDefault(require("./ListItensLeft"));
var _ModalClient = _interopRequireDefault(require("../../client/ModalClient.vue"));
var _ModalTag = _interopRequireDefault(require("../../batch/ModalTag.vue"));
var _ContentBatch = _interopRequireDefault(require("../../batch/ContentBatch.vue"));
var _ModalClassification = _interopRequireDefault(require("../../batch/ModalClassification.vue"));
var _ModalFormServiceCycles = _interopRequireDefault(require("@/ui/components/ModalFormServiceCycles"));
var _ModalFormOrderService = _interopRequireDefault(require("@/ui/components/ModalFormOrderService"));
var _components = require("@/ui/components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'ContentSchedulingComponent',
  components: {
    ListItensLeft: _ListItensLeft.default,
    Colapse: _Colapse.default,
    TheMask: _vueTheMask.TheMask,
    Money: _vMoney.Money,
    ModalClient: _ModalClient.default,
    ModalTag: _ModalTag.default,
    ContentBatch: _ContentBatch.default,
    ModalClassification: _ModalClassification.default,
    DatePicker: _components.DatePicker,
    AppSelect: _components.AppSelect,
    // eslint-disable-next-line vue/no-unused-components
    AppInput: _components.AppInput
  },
  data: function data() {
    var today = new Date();
    return {
      date: new Date(),
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      dataUsers: [],
      clients: [],
      clientSelectedIndex: 0,
      btchProducts: [],
      products: [],
      showModalClient: false,
      showModalTag: false,
      showContentBatch: false,
      showModalClassification: false,
      selectedPrintBatch: null,
      batchUpdate: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      month: null,
      comment: '',
      dataWorkers: [],
      isFetching: false,
      erroCommnet: false,
      months: [{
        value: 0
      }, {
        value: 1
      }, {
        value: 2
      }, {
        value: 3
      }, {
        value: 4
      }, {
        value: 5
      }, {
        value: 6
      }, {
        value: 7
      }, {
        value: 8
      }, {
        value: 9
      }, {
        value: 10
      }, {
        value: 11
      }],
      statusItens: [{
        name: '',
        value: null
      }, {
        name: 'Agendado',
        value: 'SCHEDULED'
      }, {
        name: 'Em andamento',
        value: 'IN_PROGRESS'
      }, {
        name: 'Concluído',
        value: 'FINISHED'
      }],
      timePeriod: [{
        name: '',
        value: null
      }, {
        name: 'Diário',
        value: 'DAY'
      }, {
        name: 'Semanal',
        value: 'WEEK'
      }, {
        name: 'Quinzenal',
        value: 'BIWEEKLY'
      }, {
        name: 'Mensal',
        value: 'MONTH'
      }],
      autoAplicationOptions: [{
        name: '',
        value: null
      }, {
        name: 'Sim',
        value: true
      }, {
        name: 'Não',
        value: false
      }],
      selectedOccurrence: null,
      selectOperator: '',
      selectClient: '',
      listOperators: [],
      listClients: [],
      customFieldsColheita: [{
        name: 'Distribuidor',
        placeholder: 'Nome do distribuidor',
        input: 'STRING'
      }, {
        name: 'Peso da Caixa',
        placeholder: '00 Kg',
        input: 'NUMBER'
      }, {
        name: 'Valor do Kilo',
        placeholder: 'R$ 00,00',
        input: 'NUMBER'
      }],
      serviceProgress: 0
    };
  },
  props: {
    step: {
      type: Number,
      default: null
    },
    scheduling: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    returnStep: {
      type: Function,
      default: function _default() {}
    },
    loadLines: {
      type: Function,
      default: function _default() {}
    },
    plotSelected: {
      type: Number,
      default: null
    },
    isService: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    checkedPlots: 'checkedPlots',
    storeServicetypes: 'storeServicetypes',
    serviceSelected: 'serviceSelected',
    allOcurrences: 'allOcurrences',
    cyclesList: 'getCyclesList',
    orderServiceList: 'getOrderServiceList'
  })), {}, {
    selectedClient: function selectedClient() {
      return this.listClients[this.clientSelectedIndex];
    },
    filteredOperators: function filteredOperators() {
      var self = this;
      var operators = self.dataWorkers;
      var selectOperator = self.scheduling.workers;
      if (selectOperator.length) {
        var list = operators.filter(function (item) {
          return selectOperator.find(function (op) {
            return item.id !== op.id;
          });
        });
        return list;
      }
      return operators;
    },
    filteredClients: function filteredClients() {
      var self = this;
      var clients = self.clients;
      if (clients) {
        var list = clients.filter(function (item) {
          return item.name.includes(self.selectClient);
        });
        return list;
      }
      return [];
    },
    isColheita: function isColheita() {
      return this.serviceSelected && this.serviceSelected.name.toUpperCase().trim() === 'COLHEITA';
    },
    isTypeService: function isTypeService() {
      var _this = this;
      var item = this.storeServicetypes.find(function (i) {
        return i.id === _this.scheduling.typeService;
      });
      return item || null;
    },
    showColheitaInformation: function showColheitaInformation() {
      return this.isTypeService && this.isTypeService.name && this.isTypeService.name.toUpperCase().trim() === 'COLHEITA';
    },
    showBatchRegister: function showBatchRegister() {
      return this.showContentBatch || this.batchProductsClient.length === 0;
    },
    dateServiceFollowUpActivity: function dateServiceFollowUpActivity() {
      if (!this.serviceSelected.type.followUpTypeId) return '--';
      var value = this.serviceSelected.type.followUpTimeValue;
      var type = this.serviceSelected.type.followUpTimeUnit;
      var date = this.serviceSelected.dueDate;
      var newDate = (0, _moment.default)(date).add(value, type);
      var day = newDate.format('DD');
      var month = newDate.format('MM');
      var year = newDate.format('YYYY');
      var dateFollowUp = day + '/' + month + '/' + year;
      return dateFollowUp;
    },
    serviceFollowUpActivity: function serviceFollowUpActivity() {
      if (!this.serviceSelected.type.followUpTypeId) return {};
      var idService = this.serviceSelected.type.followUpTypeId;
      var service = this.storeServicetypes.find(function (item) {
        return item.id === idService;
      });
      return service;
    },
    disabledItem: function disabledItem() {
      return this.serviceSelected && this.serviceSelected.status && this.serviceSelected.status.toLowerCase() === 'FINISHED'.toLowerCase();
    },
    disableProgress: function disableProgress() {
      return this.serviceSelected && this.serviceSelected.status && this.serviceSelected.status.toLowerCase() === 'IN_PROGRESS'.toLowerCase();
    },
    batchProductsClient: function batchProductsClient() {
      var clients = this.listClients;
      var selectedIndex = this.clientSelectedIndex;
      if (!this.btchProducts) return [];
      var products = this.btchProducts;
      return products.filter(function (item) {
        if (clients && clients.length > 0) {
          return item.clientId === clients[selectedIndex].id;
        }
        return false;
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;
    this.getServicesTypesRest();
    this.loadClients();
    this.loadBatch();
    this.getProducts();
    this.fectchAllCyclesServices();
    this.fectchAllOrderServices();
    this.month = this.months.filter(function (item) {
      return item === _this2.date.getMonth();
    })[0];
    if (this.isColheita && !this.isService) {
      this.scheduling.customFields = this.customFieldsColheita;
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['findUser', 'getListSchedulingService', 'setLoading', 'getProgress', 'fectchServiceProgess', 'getBunches', 'fetchClient', 'createClient', 'fetchProducts', 'deleteBatchById', 'fectchAllCyclesServices', 'fectchAllOrderServices'])), {}, {
    getProduct: function getProduct(id) {
      return this.products.find(function (item) {
        return item.id === id;
      });
    },
    getVariety: function getVariety(id) {
      if (this.products) {
        var product = this.products.find(function (item) {
          if (item.varieties) {
            return item.varieties.find(function (itv) {
              return itv.id === id;
            });
          } else {
            return false;
          }
        });
        if (product) {
          return product.varieties.find(function (itv) {
            return itv.id === id;
          });
        }
      }
      return null;
    },
    getCultivation: function getCultivation(idVariety, idCultivation) {
      var cultivation = this.getVariety(idVariety);
      if (cultivation && cultivation.cultivations) {
        return cultivation.cultivations.find(function (item) {
          return item.id === idCultivation;
        });
      }
      return null;
    },
    getProducts: function () {
      var _getProducts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.fetchProducts();
            case 1:
              this.products = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getProducts() {
        return _getProducts.apply(this, arguments);
      }
      return getProducts;
    }(),
    deleteClient: function deleteClient() {
      var deletedItem = this.listClients.splice(this.clientSelectedIndex, 1)[0];
      var indexDeleteClient = this.scheduling.clientsId.indexOf(function (i) {
        return i.id === deletedItem.id;
      });
      if (indexDeleteClient > -1) {
        this.scheduling.clientsId.splice(indexDeleteClient, 1);
      }
      var indexDeleteBatch = this.scheduling.batchsId.indexOf(function (i) {
        return i.clientId === deletedItem.id;
      });
      if (indexDeleteBatch > -1) {
        this.scheduling.batchsId.splice(indexDeleteBatch, 1);
      }
      if (this.clientSelectedIndex > 0) {
        this.clientSelectedIndex--;
      }
    },
    openModalClassification: function openModalClassification() {
      this.showModalClassification = true;
    },
    openModalClient: function openModalClient() {
      this.showModalClient = !this.showModalClient;
    },
    openModalBatch: function openModalBatch() {
      this.showContentBatch = !this.showContentBatch;
    },
    printTag: function printTag(batch) {
      this.selectedPrintBatch = batch;
      this.showModalTag = !this.showModalTag;
    },
    selectedItens: function selectedItens(arrayItem) {
      return arrayItem.filter(function (item) {
        return item.checked;
      });
    },
    selectPlot: function selectPlot(index) {
      this.$emit('update:plotSelected', index);
    },
    deleteBatch: function () {
      var _deleteBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(batch) {
        var index;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.deleteBatchById(batch.id);
            case 1:
              if (this.btchProducts) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, []);
            case 2:
              index = this.btchProducts.indexOf(batch);
              if (index > -1) {
                this.btchProducts.splice(index, 1);
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function deleteBatch(_x) {
        return _deleteBatch.apply(this, arguments);
      }
      return deleteBatch;
    }(),
    editBatch: function editBatch(batchPrd) {
      this.batchUpdate = batchPrd;
      this.openModalBatch();
    },
    onInsertComment: function onInsertComment(e) {
      var comment = this.comment.trim();
      if (comment && comment.length >= 10) {
        this.erroCommnet = false;
        var item = {
          date: (0, _moment.default)().format(),
          comment: comment
        };
        this.scheduling.logs.push(item);
        comment = '';
        var commnets = this.scheduling.logs;
        this.scheduling.logs = commnets.sort((0, _utils.sortBy)('date'));
        // apenas para colar o scroll para facilitar usabilidade
        document.getElementsByClassName('modal-body')[0].scrollTop = document.getElementById('mainCenter').scrollHeight;
      } else {
        if (e.type !== 'blur') this.erroCommnet = true;
      }
      this.comment = '';
    },
    onInsertWorker: function onInsertWorker(operator) {
      if (!operator) return null;
      var item = operator;
      var idt = this.scheduling.workers.filter(function (item) {
        return item.firstName === operator.firstName;
      });
      if (!idt.length) {
        this.scheduling.workers.push(item);
        var users = this.scheduling.workers;
        this.scheduling.workers = users.sort((0, _utils.sortBy)('firstName'));
      }
    },
    onInsertClient: function onInsertClient(client) {
      if (!client) return null;
      var item = client;
      var idt = this.listClients.filter(function (item) {
        return item.id === client.id;
      });
      if (!idt.length) {
        if (!this.scheduling.clientsId) this.scheduling.clientsId = [];
        this.listClients.push(item);
        this.scheduling.clientsId.push(client.id);
        this.listClients.pop();
      }
    },
    addOcurrences: function addOcurrences(occurrence) {
      if (!occurrence) return null;
      var idt = this.scheduling.occurrencies.filter(function (item) {
        return item.id === occurrence.id;
      });
      if (!idt.length) {
        this.scheduling.occurrencies.push(occurrence);
      }
    },
    deleteWorker: function deleteWorker(operator) {
      this.scheduling.workers = this.scheduling.workers.filter(function (item) {
        return item.id !== operator.id;
      });
    },
    returnStepDown: function returnStepDown() {
      if (this.serviceSelected && this.serviceSelected.status && this.serviceSelected.status.toLowerCase() === 'FINISHED'.toLowerCase()) {
        this.$buefy.toast.open({
          type: 'is-warning',
          message: 'Não é permitido alterar um serviço já Finalizado!'
        });
      } else this.$emit('returnStep');
    },
    getProgressService: function () {
      var _getProgressService = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.fectchServiceProgess();
            case 1:
              res = _context3.v;
              if (res) {
                this.serviceProgress = res.progress || 0;
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getProgressService() {
        return _getProgressService.apply(this, arguments);
      }
      return getProgressService;
    }(),
    getAsyncData: function () {
      var _getAsyncData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(name) {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (name.length) {
                _context4.n = 1;
                break;
              }
              this.dataWorkers = [];
              return _context4.a(2);
            case 1:
              this.isFetching = true;
              _context4.n = 2;
              return this.findUser({
                name: name
              });
            case 2:
              res = _context4.v;
              this.isFetching = false;
              if (res) this.dataWorkers = res.data;else this.dataWorkers = [];
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getAsyncData(_x2) {
        return _getAsyncData.apply(this, arguments);
      }
      return getAsyncData;
    }(),
    getServicesTypesRest: function () {
      var _getServicesTypesRest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var productsIds;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.setLoading(true);
              productsIds = [];
              this.checkedPlots.map(function (item, id) {
                item.subplots.map(function (sub, idx) {
                  if (sub.productId) {
                    productsIds.push(sub.productId);
                  }
                });
              });
              _context5.n = 1;
              return this.getListSchedulingService(productsIds);
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function getServicesTypesRest() {
        return _getServicesTypesRest.apply(this, arguments);
      }
      return getServicesTypesRest;
    }(),
    loadBunches: function () {
      var _loadBunches = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(familie, sub) {
        var payload;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              payload = {
                idxPlot: this.plotSelected,
                idSubPlot: sub.id,
                item: familie,
                step: this.step
              };
              _context6.n = 1;
              return this.getBunches(payload);
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function loadBunches(_x3, _x4) {
        return _loadBunches.apply(this, arguments);
      }
      return loadBunches;
    }(),
    loadFamilies: function () {
      var _loadFamilies = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(line) {
        var payload;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              payload = {
                item: line,
                idxPlot: this.plotSelected,
                step: this.step
              };
              _context7.n = 1;
              return this.getFamilies(payload);
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function loadFamilies(_x5) {
        return _loadFamilies.apply(this, arguments);
      }
      return loadFamilies;
    }(),
    loadClients: function () {
      var _loadClients = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (this.scheduling.clientsId) {
                this.listClients = this.scheduling.clientsId;
              }
              _context8.n = 1;
              return this.fetchClient();
            case 1:
              this.clients = _context8.v;
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function loadClients() {
        return _loadClients.apply(this, arguments);
      }
      return loadClients;
    }(),
    loadBatch: function () {
      var _loadBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              this.btchProducts = this.scheduling.batchsId || [];
            case 1:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function loadBatch() {
        return _loadBatch.apply(this, arguments);
      }
      return loadBatch;
    }(),
    resolvedCallbackModalClient: function () {
      var _resolvedCallbackModalClient = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(item) {
        var client;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (!item) {
                _context0.n = 2;
                break;
              }
              this.showModalClient = false;
              this.setLoading(true);
              _context0.n = 1;
              return this.createClient(item);
            case 1:
              client = _context0.v;
              this.clients.push(client);
              if (this.scheduling.clientsId) this.scheduling.clientsId = [];
              this.scheduling.clientsId.push(item.id);
              this.listClients.push(client);
              _context0.n = 3;
              break;
            case 2:
              this.showModalClient = false;
              this.clientSelectedIndex = 0;
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function resolvedCallbackModalClient(_x6) {
        return _resolvedCallbackModalClient.apply(this, arguments);
      }
      return resolvedCallbackModalClient;
    }(),
    resolvedCallbackModalTag: function () {
      var _resolvedCallbackModalTag = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(item) {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this.showModalTag = false;
            case 1:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function resolvedCallbackModalTag(_x7) {
        return _resolvedCallbackModalTag.apply(this, arguments);
      }
      return resolvedCallbackModalTag;
    }(),
    resolvedCallbackModalClassification: function () {
      var _resolvedCallbackModalClassification = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(item) {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              this.showModalClassification = false;
            case 1:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function resolvedCallbackModalClassification(_x8) {
        return _resolvedCallbackModalClassification.apply(this, arguments);
      }
      return resolvedCallbackModalClassification;
    }(),
    resolvedCallbackModalBatch: function () {
      var _resolvedCallbackModalBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(item) {
        var index;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              this.showContentBatch = false;
              this.batchUpdate = null;
              if (item) {
                if (item.update) {
                  index = this.btchProducts.indexOf(function (e) {
                    return e.id === item.id;
                  });
                  if (index !== -1) {
                    this.btchProducts[index] = item;
                  }
                } else {
                  if (!this.scheduling.batchsIds) {
                    this.scheduling.batchsIds = [];
                  }
                  this.scheduling.batchsIds.push(item.id);
                  this.btchProducts.push(item);
                }
              }
            case 1:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function resolvedCallbackModalBatch(_x9) {
        return _resolvedCallbackModalBatch.apply(this, arguments);
      }
      return resolvedCallbackModalBatch;
    }(),
    modalAddCycles: function modalAddCycles() {
      this.$buefy.modal.open({
        parent: this,
        component: _ModalFormServiceCycles.default,
        hasModalCard: true,
        customClass: 'modal-service-cycles-component',
        trapFocus: true
      });
    },
    modalAddOrderService: function modalAddOrderService() {
      this.$buefy.modal.open({
        parent: this,
        component: _ModalFormOrderService.default,
        hasModalCard: true,
        customClass: 'modal-service-order-service-component',
        trapFocus: true
      });
    }
  })
};